interface Props {
    status?: 'success' | 'danger'
    onClose: (value: Boolean) => void
    title: string
    description?: string
    buttonText?: string
    open?: boolean
}

export default function UnauthorizedAlert({
    status = 'success',
    onClose,
    title,
    description,
    buttonText = 'Confirmar',
    open,
}: Props) {
    const colors = {
        success: '#50cd89',
        danger: '#f1416c',
    }

    return (
        <div
            className='w-100 h-100 position-fixed top-0 start-0'
            style={{
                transition: 'opacity 2s',
                display: open ? 'block' : 'none',
                opacity: open ? '1' : '0',
                zIndex: 1050, // Ajuste para garantir que fique acima do conteúdo
            }}
        >
            <div
                className='w-100 h-100 position-fixed top-0 start-0'
                style={{backdropFilter: `blur(5px)`}}
            ></div>
            <div
                className={`shadow-lg alert alert-${status} position-fixed top-50 start-50 translate-middle py-10 px-10 px-lg-20 mb-10`}
                style={{zIndex: 1060}} // Colocar o alerta acima do backdrop
            >
                <span className='w-100 d-flex justify-content-center py-5'>
                    <i
                        className={`fas fa-${status === 'success' ? 'check' : 'times'}-circle`}
                        style={{color: colors[status], fontSize: '50px'}}
                    ></i>
                </span>
                <div className='text-center'>
                    <h1 className='fw-bolder mb-5'>{title}</h1>
                    {description && (
                        <>
                            <div
                                className={`separator separator-dashed border-${status} opacity-25 mb-5`}
                            ></div>
                            <div className='mb-9 text-dark'>
                                {description}
                                <br />
                            </div>
                        </>
                    )}
                    <div className='d-flex flex-center flex-wrap'>
                        <button
                            onClick={() => {
                                onClose(false)
                            }}
                            className={`btn btn-${status} m-2`}
                        >
                            {buttonText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
